<template>
  <div>
    <wizardModal
      modal-id="bosch-panels-wizard"
      :is-active.sync="localIsActive"
      :is-add="isAdd"
      :wizard-title="wizardTitle"
      :steps="wizardSteps"
      :step-icons="wizardStepIcons"
      :finishAtStep="finishAtStep"
      :current-step.sync="currentStep"
      :show-previous-button="false"
      :show-save-button="!isAdd && currentStep < finishAtStep && !isProcessing"
      :show-next-button="false"
      :show-finish-button="currentStep === finishAtStep && !isProcessing"
      :activate-btn-save="!isAdd && hasChanges"
      :disable-next="isProcessing"
      :loading="isProcessing"
      @close-wizard="closeWizard"
      @prev-step="prevStep"
      @next-step="nextStep"
      @save-data="handleSave"
      @load-data="loadData"
      @reset-wizard="resetData"
      @on-submit="onSubmit"
    >
      <template #step-0="currentStep, loading">
        <div class="position-relative">
          <general-step
            ref="generalStep"
            :item-data="itemData"
            :profile-options="profileOptions"
            :profile-loading="isLoadingProfiles"
            :facilities-options="facilitiesOptions"
            :center-options="centerOptions"
            :sector-options="sectorOptions"
            :reseller-options="resellerOptions"
          />

          <loading-overlay
            :visible="isCreatingPanel"
            message="Creating panel..."
            variant="primary"
          />
        </div>
      </template>
    </wizardModal>
  </div>
</template>

<script>
import WizardModal from "@/components/WizardModal/Index.vue";
import GeneralStep from "./GeneralStep.vue";
import LoadingOverlay from "./LoadingOverlay.vue";
import useBoschPanelsWizard from "./useBoschPanelsWizard.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";

export default {
  name: "BoschPanelsWizard",
  components: {
    WizardModal,
    GeneralStep,
    LoadingOverlay,
    ToastificationContent,
  },
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    itemEdit: {
      type: Object,
      required: false,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    facilitiesOptions: {
      type: Array,
      required: true,
    },
    centerOptions: {
      type: Array,
      required: true,
    },
    sectorOptions: {
      type: Array,
      required: true,
    },
    resellerOptions: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const toast = useToast();
    return {
      ...useBoschPanelsWizard(props, { emit }),
      toast,
    };
  },
  computed: {
    isProcessing() {
      return this.isCreatingPanel;
    }
  },
};
</script>
<style lang="scss" scoped></style>
